<template lang="pug">
  nav.navbar(v-if="settings" :class="{ minimized: isMinimized }")
    div.div.container
      .navbar-brand
        a.navbar-item(href="//www.ogs.trieste.it/" title="OGS Website")
          img(class="logo" src="./../assets/logo-ogs.png" alt="logo" width="auto" height="54")
        router-link(to="/" exact class="navbar-item")
          img(class="logo" src="./../assets/logo-maos.png" alt="logo" width="auto" height="43")
      .navbar-menu
        ul.navbar-end
          li(v-for="item in settings.mainmenu" :class="{ 'navbar-item': item.nodes, 'has-dropdown': item.nodes, 'is-hoverable': item.nodes }")
            router-link(v-if="item.title === 'Instruments'" exact :to="item.slug" class="navbar-item" active-class="is-active" :class="{ 'navbar-link': item.nodes, 'is-active': isActive}") {{ item.title }}
            router-link(v-else exact :to="item.slug" class="navbar-item" active-class="is-active" :class="[{'navbar-link': item.nodes}, item.slug.substring(1)]") {{ item.title }}
            ul(v-if="item.nodes" class="navbar-dropdown is-boxed")
              li(v-for="subitem in item.nodes")
                router-link(:to="subitem.slug" class="navbar-item" active-class="is-active") {{ subitem.title }}
      div.menu-button(@click="toggleMenu")
        span
        span
        span
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'mainmenu',
  computed: mapState([
    'settings'
  ]),
  data () {
    return {
      isMinimized: false,
      isActive: false
    }
  },
  watch: {
    '$route.path': function (path) {
      if (this.$route.name === 'Instruments Type') {
        this.isActive = true
      }
    }
  },
  methods: {
    minimizedNav () {
      if (window.scrollY > 0 && window.innerWidth > 1024) {
        this.isMinimized = true
      } else {
        this.isMinimized = false
      }
    },
    toggleMenu () {
      document.body.classList.toggle('open-menu')
    }
  },
  mounted () {
    window.addEventListener('scroll', this.minimizedNav)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/MainMenu.vue